'use client';

import { c as _c } from "react/compiler-runtime";
import { useQuery } from '@tanstack/react-query';
import { fetchPrV2OrderedFiles } from './fetch-pr-v2';
import { prV2OrderedFilesQueryKey } from './query-keys';
const PR_V2_ORDERED_FILES_PENDING_POLL_MS = 2000;

/**
 * Poll the lightweight ordered-files status route while the main code-changes payload renders with
 * fallback grouping. This keeps first paint fast and only refetches the small AI-ordering status
 * document until the cached ordered files become ready.
 */
export function usePrV2OrderedFiles(owner, repo, number, options) {
  const $ = _c(16);
  const t0 = options?.headSha;
  const t1 = options?.baseSha;
  let t2;
  if ($[0] !== number || $[1] !== owner || $[2] !== repo || $[3] !== t0 || $[4] !== t1) {
    t2 = prV2OrderedFilesQueryKey(owner, repo, number, t0, t1);
    $[0] = number;
    $[1] = owner;
    $[2] = repo;
    $[3] = t0;
    $[4] = t1;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  if ($[6] !== number || $[7] !== options?.baseSha || $[8] !== options?.headSha || $[9] !== owner || $[10] !== repo) {
    t3 = t4 => {
      const {
        signal
      } = t4;
      return fetchPrV2OrderedFiles(owner, repo, number, {
        headSha: options?.headSha,
        baseSha: options?.baseSha
      }, signal);
    };
    $[6] = number;
    $[7] = options?.baseSha;
    $[8] = options?.headSha;
    $[9] = owner;
    $[10] = repo;
    $[11] = t3;
  } else {
    t3 = $[11];
  }
  const t4 = Boolean(owner && repo && number && options?.headSha && options?.baseSha) && (options?.enabled ?? true);
  let t5;
  if ($[12] !== t2 || $[13] !== t3 || $[14] !== t4) {
    t5 = {
      queryKey: t2,
      queryFn: t3,
      enabled: t4,
      staleTime: Number.POSITIVE_INFINITY,
      refetchOnWindowFocus: false,
      refetchInterval: _temp
    };
    $[12] = t2;
    $[13] = t3;
    $[14] = t4;
    $[15] = t5;
  } else {
    t5 = $[15];
  }
  return useQuery(t5);
}
function _temp(query) {
  return query.state.data?.status === "pending" ? PR_V2_ORDERED_FILES_PENDING_POLL_MS : false;
}